module.exports = __webpack_public_path__ + "static/media/Street-day.97bb8a89.svg";